/***************************************************************
 *  action status
 ***************************************************************/
export const DO_INIT_MENU = 'DO_INIT_MENU';
export const DO_ACTIVE_PAGE = 'DO_ACTIVE_PAGE';
export const DO_ACTIVE_SUB_PAGE = 'DO_ACTIVE_SUB_PAGE';
export const DO_CHANGE_SIMPLE_MODE = 'DO_CHANGE_SIMPLE_MODE';
export const DO_CHANGE_DETAIL_MODE = 'DO_CHANGE_DETAIL_MODE';

/***************************************************************
 *  action function
 ***************************************************************/
export const leaveMenu = () => (dispatch) => {
    dispatch({
        type: DO_INIT_MENU
    });
}

export const doActivePage = (pageName, data) => (dispatch) => {
    dispatch({
        type: DO_ACTIVE_PAGE,
        params: {
            activePage: pageName,
            data: data
        }
    });
};

export const doActiveSubPage = (pageName) => (dispatch) => {
    dispatch({
        type: DO_ACTIVE_SUB_PAGE,
        params: {
            activeSubPage: pageName
        }
    });
};

export const doChangeSimpleMode = () => (dispatch) => {
    dispatch({
        type: DO_CHANGE_SIMPLE_MODE
    });
}

export const doChangeDetailMode = () => (dispatch) => {
    dispatch({
        type: DO_CHANGE_DETAIL_MODE
    });
}